import React, {useContext, useState} from "react";
import UserContext from "../common/UserContext";
import {useLocalization} from "@progress/kendo-react-intl";
import {mainMessages, myAssignedProductsKey, requestLicenseSummaryKey} from "../../assets/text/MultilingualText";
import {LicensePreview} from "./RequestDownload/LicensePreview";
import {LicenseDownload} from "./RequestDownload/LicenseDownload";

export default function RequestDownload(props) {
    const {
        siteLanguageDefault,
    } = useContext(UserContext);

    const localization = useLocalization();
    const [requestedLicense, setRequestedLicense] = useState(false)
    const [requestedProducts, setRequestedProducts] = useState([])

    return (
        <>
            <div
                className={'k-h5'}
                style={{
                    marginBottom: '0.938rem'
                }}
            >
                {localization.toLanguageString(requestLicenseSummaryKey, mainMessages[siteLanguageDefault][requestLicenseSummaryKey])}
            </div>

            <div
                className={'k-h5'}
                style={{
                    marginBottom: '0.938rem'
                }}
            >
                {localization.toLanguageString(myAssignedProductsKey, mainMessages[siteLanguageDefault][myAssignedProductsKey])}
            </div>

            {!requestedLicense && (
                <LicensePreview
                    setRequestedLicense={setRequestedLicense}
                    setRequestedProducts={setRequestedProducts}
                />
            )}

            {requestedLicense && (
                <LicenseDownload
                    requestedProducts={requestedProducts}
                    setRequestedProducts={setRequestedProducts}
                />
            )}
        </>
    )

}